import React from 'react';
import { FaJava, FaReact, FaAws, FaDocker } from 'react-icons/fa';
import {
  SiSpringboot,
  SiApachekafka,
  SiKubernetes,
  SiPostgresql,
  SiRedis,
  SiElasticsearch,
  SiTerraform,
  SiTypescript,
  SiGithubactions,
  SiJenkins,
  SiPython,
  SiMongodb,
} from 'react-icons/si';

const techs = [
  { name: 'Java', icon: FaJava },
  { name: 'Spring Boot', icon: SiSpringboot },
  { name: 'Kafka', icon: SiApachekafka },
  { name: 'AWS', icon: FaAws },
  { name: 'Kubernetes', icon: SiKubernetes },
  { name: 'Docker', icon: FaDocker },
  { name: 'PostgreSQL', icon: SiPostgresql },
  { name: 'Redis', icon: SiRedis },
  { name: 'Elasticsearch', icon: SiElasticsearch },
  { name: 'Terraform', icon: SiTerraform },
  { name: 'React', icon: FaReact },
  { name: 'TypeScript', icon: SiTypescript },
  { name: 'GitHub Actions', icon: SiGithubactions },
  { name: 'Jenkins', icon: SiJenkins },
  { name: 'Python', icon: SiPython },
  { name: 'MongoDB', icon: SiMongodb },
];

const Experience = () => {
  return (
    <section
      id="experience"
      className="bg-gradient-to-b from-gray-950 to-black w-full text-white py-24"
    >
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.25em] text-cyan-400 font-semibold mb-2">
            Technical toolkit
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold">
            Skills & Technologies
          </h2>
          <p className="mt-4 text-gray-400 text-lg">
            A focused view of the technologies I use to build, ship, and operate
            software.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {techs.map(({ name, icon: Icon }) => (
            <div
              key={name}
              className="group rounded-2xl border border-white/10 bg-white/[0.04] p-5 flex flex-col items-center justify-center min-h-[145px] transition hover:-translate-y-1 hover:border-cyan-400/40 hover:bg-white/[0.07]"
            >
              <Icon className="text-4xl text-gray-200 transition group-hover:text-cyan-300" />
              <p className="mt-4 text-sm sm:text-base font-semibold text-center text-gray-200">
                {name}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {[
            'Spring Security',
            'Spring Cloud',
            'OpenTelemetry',
            'Prometheus',
            'Grafana',
            'CloudWatch',
            'Hibernate',
            'Maven',
            'Gradle',
            'GraphQL',
            'GCP',
            'Linux',
          ].map((item) => (
            <span
              key={item}
              className="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 text-sm text-gray-400"
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
